import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Getrequest, Putrequest } from '../../../../context/AxiosRequest';
import { ContextData } from '../../../../context/Context';
import { toast } from 'react-toastify';
import SoundAlert from '../../../../routes/SoundAlert';
import { isEmpty } from 'lodash';
import GetPersonData from '../../../../context/GetPersonData';
import { useNavigate } from 'react-router-dom';

export default function AutoNotfication() {

  const [open, setOpen] = React.useState(false);
  const {UserTokens,accesstoken} = React.useContext(ContextData)
  const [BtnStatus,setBtnStatus]  = React.useState(false)
  const [Reload,setReload] = React.useState(true)
  const Navigate = useNavigate()

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

   React.useEffect(()=>{

          GetPersonData(UserTokens,accesstoken).then(res=>{
                   const verify_status = res.sign_up[0]?.verify_status
                 
                    if(verify_status  === "pending"){
                      Getrequest(`/auth/check_if_returned/${UserTokens}`,accesstoken).then(res=>{
                                         if(res.status){
                                               toast.success(res.textStatus)
                                                 setOpen(true)
                                                 SoundAlert("error")
                                         }else if(!res.status){
                                               setOpen(true)
                                              // toast.warn(res.textStatus)
                                         }
                      })
                    }
         })
   },[Reload])

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    const code = formJson.code;

       if(!UserTokens && !accesstoken) return toast.warn("Error Credentials, maybe refresh the page or login again!")

          if(isEmpty(code)) {
            toast.warn("no empty input is allow") 
            SoundAlert("error")
            return
          } 
    
         (async ()=>{
               const response = await Getrequest(`/auth/verify_code/${UserTokens}/${code}`,accesstoken)
                   if(response.status){
                       toast.success(response.textStatus)
                       SoundAlert("suucess")
                         setOpen(false)
                   }else if(!response.status){
                       toast.warn(response.textStatus)
                       SoundAlert("error")
                   }
           })()
  };

  const GetCode = ()=>{
           (async ()=>{
               const response = await Getrequest("/auth/generate_code/"+UserTokens,accesstoken)
                   if(response.status){
                       toast.success(response.textStatus)
                       SoundAlert("success")
                       setBtnStatus(true)
                    const timer = setTimeout(() => {
                      setBtnStatus(false);
                      clearTimeout(timer);
                    }, 5 * 60 * 1000); // 5 minutes
                   }else if(!response.status){
                       toast.warn(response.textStatus)
                       SoundAlert("error")
                   }
           })()
  }

  const ContactUs = ()=>{

      Navigate("/application/student_support") 
      setOpen(false)
  } 

  return (
    <React.Fragment>
      <Dialog
        open={open}
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            m: 0,
            width: '100%',
            maxWidth: '100%',
            borderRadius: isMobile ? 0 : 2,
            // ensure no horizontal margin on small screens
          }
        }}
      >
        <DialogTitle sx={{ px: { xs: 1, sm: 3 }, py: { xs: 1.25, sm: 2 } }}>
          <span className='font-mono'>Return Application</span>
        </DialogTitle>
        <DialogContent
          sx={{
            px: { xs: 0, sm: 3 }, // no left/right padding on xs
            py: { xs: 1.5, sm: 2 },
            '& .font-mono, & p, & h1, & h': { // improve readability on small screens
              fontSize: { xs: '0.95rem', sm: '1rem' },
              lineHeight: 1.35,
              
            }
            
          }}
        >
          <DialogContentText sx={{ textAlign: "center", px: { xs: 1, sm: 0 } }}>
             <h className="text-red-900 text-4xl font-extrabold font-mono">Your Application Has Been Returned - Action Required</h>
          </DialogContentText>
               <h1 className='text-red-600 text-3xl font-semibold text-center pt-5 '>Important Notice</h1>

                <p className='font-mono text-pretty p-4' style={{ paddingLeft: isMobile ? 12 : undefined, paddingRight: isMobile ? 12 : undefined }}>
            <span > <b className=''>Dear Applicant</b>, your application has been returned for you to fix some issues from the submission you made during your application process. Please check your dashboard mailbox or the email you used during sign-up. Make sure you still have access to your email because all correspondence will be through email and your dashboard.</span>
             </p>

             <p className='p-4 font-mono text-justify' style={{ paddingLeft: isMobile ? 12 : undefined, paddingRight: isMobile ? 12 : undefined }}>
               Once you have provided the required documents that the verifier requested, please click the <b>"Return Application"</b> button located in the top navigation bar after the mailbox icon with the red background.
             </p>
             <p className='text-red-600 font-semibold p-4 text-justify ' style={{ paddingLeft: isMobile ? 12 : undefined, paddingRight: isMobile ? 12 : undefined }}>Note: Do not return the application unless you have corrected the issues you are required to address.</p>
             <p className='text-red-600 font-semibold text-justify p-4' style={{ paddingLeft: isMobile ? 12 : undefined, paddingRight: isMobile ? 12 : undefined }}>Note that this notification dialog will continue to appear until you return the application.</p>
             <p className='p-4 ' style={{ paddingLeft: isMobile ? 12 : undefined, paddingRight: isMobile ? 12 : undefined }}>Should you have technical issue click: <Button onClick={ContactUs} variant='outlined'>Contact us</Button></p>
        </DialogContent>
        <DialogActions sx={{ px: { xs: 1, sm: 2 }, pb: { xs: 2, sm: 2 } }}>
          <div>
          <Button onClick={()=> setOpen(false)}  name="verify" variant='contained' type="submit" form="subscription-form">
            Ok and Continue
          </Button>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
